import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import { BuildPlanContext } from '../contexts/DTC/DTCContext';
import { useHistory } from 'react-router-dom';

const DTCHome = ({}) => {
    const { dispatch } = useContext(BuildPlanContext);
    const history = useHistory();

    const containerStyles = {
        height: 300,
        backgroundColor: '#ddd',
        color: '#888',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        marginBottom: '1rem'
    };

    const handleShopPlanNav = () => {
        dispatch({ type: 'INIT', payload: { buildingCustomPlan: true } });
        history.push('/dtc/shop');
    };

    return (
        <Container>
            <div style={containerStyles}>
                HERO
                <button
                    onClick={handleShopPlanNav}
                    className='btn-primary'
                >
                    Shop Plans
                </button>
            </div>

            <div style={containerStyles}>Add Content from AEM</div>

            <div style={containerStyles}>Marketing Content</div>
        </Container>
    );
};

export default DTCHome;
